import { render, staticRenderFns } from "./ReturnMailROITable.vue?vue&type=template&id=b4356294&scoped=true&"
import script from "./ReturnMailROITable.vue?vue&type=script&lang=js&"
export * from "./ReturnMailROITable.vue?vue&type=script&lang=js&"
import style0 from "./ReturnMailROITable.vue?vue&type=style&index=0&id=b4356294&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4356294",
  null
  
)

export default component.exports